import n from"./function-uncurry-this.js";import o from"./to-object.js";var a=n,e=o,s=a({}.hasOwnProperty),O=Object.hasOwn||function(r,t){return s(e(r),t)};export{O as default};
